import React from "react";
import PropTypes from "prop-types";

function Suffix({ content }) {
  if (content) {
    return <span className="suffix">{content}</span>;
  } else {
    return null;
  }
}

Suffix.propTypes = {
  content: PropTypes.string
};

export default Suffix;
